<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-07 14:08:22
 -->
<template>
  <ul class="part5">
    <div class="title">我们是下列组织的成员 We are members of the following organization(s)</div>
    <li class="two">
      <el-input
        placeholder="请输入内容"
        v-model="part5.foundationMemberCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">
          <el-checkbox v-model="part5.foundationMember" :disabled="stateCode==6||stateCode==0?false:true">
            <p>会员编号：</p>
          </el-checkbox>
        </template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part5.discountMemberCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">
          <el-checkbox v-model="part5.discountMember" :disabled="stateCode==6||stateCode==0?false:true">
            <p>优惠代码：</p>
          </el-checkbox>
        </template>
      </el-input>

      <!-- <el-checkbox v-model="part5.foundationMember"
        >国际文化交流基金会 会员号码</el-checkbox
      ><el-input
        placeholder="请输入内容"
        v-model="part5.foundationMemberCh"
      ></el-input>
      <el-checkbox v-model="part5.foundationMember"
        >INTERKULTUR e.V., membership number</el-checkbox
      ><el-input
        placeholder="请输入内容"
        v-model="part5.foundationMemberEn"
      ></el-input>-->
    </li>
    <li class="two">
      <el-input
        placeholder="请输入内容"
        v-model="part5.foundationMemberEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">
          <el-checkbox v-model="part5.foundationMember" :disabled="stateCode==6||stateCode==0?false:true">
            <p>INTERKULTUR e.V., membership number：</p>
          </el-checkbox>
        </template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part5.discountMemberEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">
          <el-checkbox v-model="part5.discountMember" :disabled="stateCode==6||stateCode==0?false:true">
            <p>Action code：</p>
          </el-checkbox>
        </template>
      </el-input>

      <!-- <el-checkbox v-model="part5.discountMember">优惠代码：</el-checkbox>
      <el-input placeholder="请输入内容" v-model="part5.discountMemberCh"></el-input>
      <el-checkbox v-model="part5.discountMember">Action code：</el-checkbox>
      <el-input placeholder="请输入内容" v-model="part5.discountMemberEn"></el-input>-->
    </li>
    <li>
      <!-- <el-checkbox v-model="part5.others">其他：</el-checkbox>
      <el-input placeholder="请输入内容" v-model="part5.othersCh"></el-input>
      <el-checkbox v-model="part5.others">Others：</el-checkbox>
      <el-input placeholder="请输入内容" v-model="part5.othersEn"></el-input>-->

      <el-input placeholder="请输入内容" v-model="part5.othersCh" :disabled="stateCode==6||stateCode==0?false:true">
        <template slot="prepend">
          <el-checkbox v-model="part5.others" :disabled="stateCode==6||stateCode==0?false:true">
            <p>其他：</p>
          </el-checkbox>
        </template>
      </el-input>
    </li>
    <li>
      <el-input placeholder="请输入内容" v-model="part5.othersEn" :disabled="stateCode==6||stateCode==0?false:true">
        <template slot="prepend">
          <el-checkbox v-model="part5.others" :disabled="stateCode==6||stateCode==0?false:true">
            <p>Others：</p>
          </el-checkbox>
        </template>
      </el-input>
    </li>
    <!-- <li>
      <el-input placeholder="请输入内容" v-model="part5.otherEn">
        <template slot="prepend">Others：</template>
      </el-input>
    </li>-->
    <li class="member">
      <el-checkbox v-model="part5.applyFoundationMember" :disabled="stateCode==6||stateCode==0?false:true">
        <p>是否申请成为INTERKULTUR国际文化交流基金会会员</p>
      </el-checkbox>
    </li>
    <li class="member">
      <el-checkbox v-model="part5.applyFoundationMember" :disabled="stateCode==6||stateCode==0?false:true">
        <p>
          We would like to join Förderverein INTERKULTUR as full members: yes
          Remind me later.
        </p>
      </el-checkbox>
      <!-- 
      <p>
        Do you want to be a member of the foundation for international
        cultural exchange
      </p>
      <div class="right">
        <el-radio v-model="part5.applyFoundationMember" :label="true">
          <p>yes</p>
        </el-radio>
        <el-radio v-model="part5.applyFoundationMember" :label="false">
          <p>Remind me later.</p>
        </el-radio>
      </div>-->
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    organizationsh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      part5: {
        applyFoundationMember: false, //申请成为国际文化交流基金会会员
        foundationMember: false, //国际文化交流基金会 会员号码
        discountMember: false, //优惠代码
        others: false, //其他
        foundationMemberCh: "",
        foundationMemberEn: "",
        discountMemberCh: "",
        discountMemberEn: "",
        othersCh: "",
        othersEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part5.applyFoundationMember =
        this.organizationsh.applyFoundationMember;
      this.part5.foundationMember = this.organizationsh.foundationMember;
      this.part5.discountMember = this.organizationsh.discountMember;
      this.part5.others = this.organizationsh.others;
      this.part5.foundationMemberCh = this.organizationsh.foundationMemberCh;
      this.part5.foundationMemberEn = this.organizationsh.foundationMemberEn;
      this.part5.discountMemberCh = this.organizationsh.discountMemberCh;
      this.part5.discountMemberEn = this.organizationsh.discountMemberEn;
      this.part5.othersCh = this.organizationsh.othersCh;
      this.part5.othersEn = this.organizationsh.othersEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part5 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;
    .el-checkbox {
      line-height: 40px;
    }
    .el-input {
      /deep/ .el-input-group__prepend {
        border-right: 0;
        color: rgba(36, 85, 139, 1);
        background: white;
        padding-right: 0px;
      }
      /deep/.el-input__inner {
        border-left: 0;
        padding: 0 15px 0 0px;
        height: 43px;
        &:focus {
          border-color: #dcdfe6;
          outline: 0;
        }
      }
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 12px;
    }
  }
  .two {
    div {
      width: 50%;
    }
    .el-input-group--prepend {
      &:last-of-type {
        width: 50%;
      }
    }
  }
  .member {
    border: 1px solid gainsboro;
    margin-left: 100px;
    margin-right: 100px;
    padding-left: 0px;
    padding-right: 0px;
    display: flex;
    border-radius: 4px;
    padding: 0 20px;
    p {
      flex: 1;
      line-height: 43px;
    }
    .right {
      display: inline-block;
      .el-radio {
        line-height: 32px;
        /deep/ .el-radio__input {
          display: inline-block;
        }
        /deep/ .el-radio__label {
          display: inline-block;
        }
      }
      width: 35%;
    }

    // .el-radio:first-of-type {
    //   margin-left: 30%;
    // }
  }
  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
}
</style>
